import { apiRequest } from './client';
import type {
  AdminNotification,
  AdminNotificationCategory,
  AdminNotificationListResponse,
} from '../types/admin';

export type AdminNotificationFilters = {
  readonly category?: AdminNotificationCategory;
  readonly unread_only?: boolean;
  readonly page?: number;
  readonly page_size?: number;
};

export type UnreadCountResponse = {
  readonly unread_count: number;
};

function buildNotificationQuery(filters: AdminNotificationFilters): string {
  const params = new URLSearchParams();
  if (filters.category) params.set('category', filters.category);
  if (filters.unread_only) params.set('unread_only', 'true');
  if (typeof filters.page === 'number') params.set('page', String(filters.page));
  if (typeof filters.page_size === 'number') params.set('page_size', String(filters.page_size));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function listAdminNotifications(
  filters: AdminNotificationFilters,
  accessToken: string,
): Promise<AdminNotificationListResponse> {
  return apiRequest<AdminNotificationListResponse>(
    `/admin/notifications${buildNotificationQuery(filters)}`,
    { token: accessToken },
  );
}

export function getUnreadCount(accessToken: string): Promise<UnreadCountResponse> {
  return apiRequest<UnreadCountResponse>('/admin/notifications/unread-count', {
    token: accessToken,
  });
}

export function markNotificationRead(
  id: string,
  accessToken: string,
): Promise<AdminNotification> {
  return apiRequest<AdminNotification>(`/admin/notifications/${id}/read`, {
    method: 'POST',
    token: accessToken,
  });
}

export function markNotificationUnread(
  id: string,
  accessToken: string,
): Promise<AdminNotification> {
  return apiRequest<AdminNotification>(`/admin/notifications/${id}/unread`, {
    method: 'POST',
    token: accessToken,
  });
}

export function deleteAdminNotification(id: string, accessToken: string): Promise<void> {
  return apiRequest<void>(`/admin/notifications/${id}`, {
    method: 'DELETE',
    token: accessToken,
  });
}
